'use client';

import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { Index, Configure } from 'react-instantsearch';
import DesktopProductListingSidebarContainer from 'components/consumer/ProductListingPage/components/desktop/DesktopProductListingSidebarContainer';
import { ALGOLIA_INDEX_NAME, ALGOLIA_PRODUCT_INDEXES } from 'commons/constants';
import QuickShipFilter from 'components/essentials/ConsumerFilters/components/QuickShipFilter';
import useAdvancedSearchContext from '../../hooks/useAdvancedSearchContext';
import SectionButtons from './components/SectionButtons';
import WidthRangeFilter from '../WidthRangeFilter';
import ClearAllFiltersButtonComponent from '../ClearAllFiltersButton';
import ProductTypeRefinementList from './components/ProductTypeRefinementList';
import useAdvancedSearchURL from '../../hooks/useAdvancedSearchURL';
const AdvancedSearchSidebar = () => {
  const $ = _c(53);
  const {
    currentSearchSection,
    updateSearchSection,
    isReadyToShipActive,
    handleToggleReadyToShip
  } = useAdvancedSearchContext();
  const {
    queryUrlParam
  } = useAdvancedSearchURL();
  let t0;
  if ($[0] !== currentSearchSection) {
    t0 = ALGOLIA_PRODUCT_INDEXES.includes(currentSearchSection);
    $[0] = currentSearchSection;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const showProductFilters = t0;
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <h2 className="text-base font-bold text-gray px-0 py-4">Refine by:</h2>;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== updateSearchSection) {
    t2 = () => {
      updateSearchSection?.(ALGOLIA_INDEX_NAME.PRODUCTS);
    };
    $[3] = updateSearchSection;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const t3 = currentSearchSection === ALGOLIA_INDEX_NAME.PRODUCTS;
  let t4;
  if ($[5] !== t2 || $[6] !== t3) {
    t4 = <SectionButtons title="Products" onClick={t2} active={t3} />;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const t5 = queryUrlParam || "";
  let t6;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = ["*"];
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = [];
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== t5) {
    t8 = <Configure query={t5} facets={t6} filters="" numericFilters="" facetFilters={t7} />;
    $[10] = t5;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== updateSearchSection) {
    t9 = () => {
      updateSearchSection?.(ALGOLIA_INDEX_NAME.CUSTOMER_PHOTOS);
    };
    $[12] = updateSearchSection;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  const t10 = currentSearchSection === ALGOLIA_INDEX_NAME.CUSTOMER_PHOTOS;
  let t11;
  if ($[14] !== t10 || $[15] !== t9) {
    t11 = <SectionButtons title="Customer Photos" onClick={t9} active={t10} />;
    $[14] = t10;
    $[15] = t9;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  let t12;
  if ($[17] !== t11 || $[18] !== t8) {
    t12 = <Index indexName={ALGOLIA_INDEX_NAME.CUSTOMER_PHOTOS}>{t8}{t11}</Index>;
    $[17] = t11;
    $[18] = t8;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  const t13 = queryUrlParam || "";
  let t14;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = ["*"];
    $[20] = t14;
  } else {
    t14 = $[20];
  }
  let t15;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = [];
    $[21] = t15;
  } else {
    t15 = $[21];
  }
  let t16;
  if ($[22] !== t13) {
    t16 = <Configure query={t13} facets={t14} filters="" numericFilters="" facetFilters={t15} />;
    $[22] = t13;
    $[23] = t16;
  } else {
    t16 = $[23];
  }
  let t17;
  if ($[24] !== updateSearchSection) {
    t17 = () => {
      updateSearchSection?.(ALGOLIA_INDEX_NAME.REVIEWS);
    };
    $[24] = updateSearchSection;
    $[25] = t17;
  } else {
    t17 = $[25];
  }
  const t18 = currentSearchSection === ALGOLIA_INDEX_NAME.REVIEWS;
  let t19;
  if ($[26] !== t17 || $[27] !== t18) {
    t19 = <SectionButtons title="Reviews" onClick={t17} active={t18} />;
    $[26] = t17;
    $[27] = t18;
    $[28] = t19;
  } else {
    t19 = $[28];
  }
  let t20;
  if ($[29] !== t16 || $[30] !== t19) {
    t20 = <Index indexName={ALGOLIA_INDEX_NAME.REVIEWS}>{t16}{t19}</Index>;
    $[29] = t16;
    $[30] = t19;
    $[31] = t20;
  } else {
    t20 = $[31];
  }
  const t21 = queryUrlParam || "";
  let t22;
  if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = ["is_active=1", "show_in_search=1", "fk_store_id=1"];
    $[32] = t22;
  } else {
    t22 = $[32];
  }
  let t23;
  if ($[33] !== t21) {
    t23 = <Configure query={t21} filters="" numericFilters={t22} />;
    $[33] = t21;
    $[34] = t23;
  } else {
    t23 = $[34];
  }
  let t24;
  if ($[35] !== updateSearchSection) {
    t24 = () => {
      updateSearchSection?.(ALGOLIA_INDEX_NAME.STATIC_PAGES);
    };
    $[35] = updateSearchSection;
    $[36] = t24;
  } else {
    t24 = $[36];
  }
  const t25 = currentSearchSection === ALGOLIA_INDEX_NAME.STATIC_PAGES;
  let t26;
  if ($[37] !== t24 || $[38] !== t25) {
    t26 = <SectionButtons title="Pages" onClick={t24} active={t25} />;
    $[37] = t24;
    $[38] = t25;
    $[39] = t26;
  } else {
    t26 = $[39];
  }
  let t27;
  if ($[40] !== t23 || $[41] !== t26) {
    t27 = <Index indexName={ALGOLIA_INDEX_NAME.STATIC_PAGES}>{t23}{t26}</Index>;
    $[40] = t23;
    $[41] = t26;
    $[42] = t27;
  } else {
    t27 = $[42];
  }
  let t28;
  if ($[43] !== handleToggleReadyToShip || $[44] !== isReadyToShipActive || $[45] !== showProductFilters) {
    t28 = showProductFilters && <><div className="mt-4"><ClearAllFiltersButtonComponent /></div><div className="mt-4"><QuickShipFilter isChecked={isReadyToShipActive} onChange={handleToggleReadyToShip} minHeight={false} withLocation={true} /></div><div className="mt-4"><WidthRangeFilter showTitle={true} /></div><div><h3 className="text-base font-bold mb-2 mt-4">Product Type</h3><ProductTypeRefinementList /></div></>;
    $[43] = handleToggleReadyToShip;
    $[44] = isReadyToShipActive;
    $[45] = showProductFilters;
    $[46] = t28;
  } else {
    t28 = $[46];
  }
  let t29;
  if ($[47] !== t12 || $[48] !== t20 || $[49] !== t27 || $[50] !== t28 || $[51] !== t4) {
    t29 = <DesktopProductListingSidebarContainer isOpen={true}>{t1}{t4}{t12}{t20}{t27}{t28}</DesktopProductListingSidebarContainer>;
    $[47] = t12;
    $[48] = t20;
    $[49] = t27;
    $[50] = t28;
    $[51] = t4;
    $[52] = t29;
  } else {
    t29 = $[52];
  }
  return t29;
};
export default AdvancedSearchSidebar;